<div class="main-container">
  <div class="mdl-container">
    <div class="d-grid mdl-header">
      <div class="center-svg">
        <img src="assets/svg/new-event-icon.svg" alt="Nuevo Evento" />
      </div>
      <div>
        <h4 class="text-semibold">Nuevo Evento</h4>
        <h6 class="color-gray" style="font-weight: 400">
          Agrega los detalles para registrar nuevo evento.
        </h6>
      </div>
      <div>
        <img
          (click)="closeMdl()"
          class="close-button"
          src="assets/svg/close-icon.svg"
          alt=""
        />
      </div>
    </div>

    <div class="mdl-body">
      <div class="step-content">
        <div
          class="d-grid prospect-form"
          style="grid-template-columns: 1fr; column-gap: 32px"
        >
          <div>
            <div class="mt-3">
              <label class="login-label"
                ><p class="color-org d-inline">*</p>
                Título del evento:</label
              >
              <input
                class="crm-input"
                type="text"
                placeholder="Ingresa el título del evento"
                [(ngModel)]="eventData.title"
                required
              />
            </div>
            <div class="mt-3">
              <label class="login-label">Descripción / Notas:</label>
              <textarea
                class="crm-input"
                placeholder="Agrega descripción o notas para el evento (opcional)"
                rows="3"
                [(ngModel)]="eventData.description"
                style="height: 98px; resize: none"
              ></textarea>
            </div>
          </div>
        </div>

        <div class="mt-4">
          <div
            class="d-grid prospect-form"
            style="
              grid-template-columns: 1fr 1fr;
              column-gap: 32px;
              align-items: start;
            "
          >
            <div>
              <div class="mt-3">
                <h1 class="text-semibold" style="font-size: 14px">
                  Inicio evento
                </h1>
                <div class="d-flex gap-2 date-time-container">
                  <div class="date-input">
                    <label class="login-label"
                      ><p class="color-org d-inline">*</p>
                      Fecha:</label
                    >
                    <input
                      class="crm-input"
                      type="date"
                      [(ngModel)]="eventData.fechaInicio"
                      [value]="getTodayDate()"
                    />
                  </div>
                  <div class="time-input">
                    <label class="login-label"
                      ><p class="color-org d-inline">*</p>
                      Hora:</label
                    >
                    <input
                      class="crm-input"
                      type="time"
                      [(ngModel)]="eventData.horaInicio"
                      value="10:00"
                    />
                  </div>
                </div>
              </div>
            </div>

            <div>
              <div class="mt-3">
                <h1 class="text-semibold" style="font-size: 14px">
                  Fin evento
                </h1>
                <div class="d-flex gap-2 date-time-container">
                  <div class="date-input">
                    <label class="login-label"
                      ><p class="color-org d-inline">*</p>
                      Fecha:</label
                    >
                    <input
                      class="crm-input"
                      type="date"
                      [(ngModel)]="eventData.fechaFin"
                      [value]="getTodayDate()"
                    />
                  </div>
                  <div class="time-input">
                    <label class="login-label"
                      ><p class="color-org d-inline">*</p>
                      Hora:</label
                    >
                    <input
                      class="crm-input"
                      type="time"
                      [(ngModel)]="eventData.horaFin"
                      value="11:00"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="mt-3">
            <label class="login-label">Ubicación:</label>
            <input
              class="crm-input"
              type="text"
              placeholder="Ingresa la ubicación del evento"
              [(ngModel)]="eventData.ubicacion"
            />
          </div>
        </div>
        <div
          class="d-grid prospect-form fixed-layout"
          style="
            grid-template-columns: 1fr 1fr;
            column-gap: 32px;
            align-items: start;
            margin-top: 24px;
          "
        >
          <div class="left-column">
            <div class="mt-3">
              <label class="login-label"
                ><p class="color-org d-inline">*</p>
                Estado:</label
              >
              <select class="crm-input" [(ngModel)]="eventData.status">
                <option value="">Selecciona el estado del evento</option>
                <option value="pendiente">Pendiente</option>
                <option value="en_progreso">En Progreso</option>
                <option value="vencida">Vencida</option>
                <option value="completada">Completada</option>
              </select>
            </div>

            <div class="mt-3">
              <label class="login-label"
                ><p class="color-org d-inline">*</p>
                Asignar a:</label
              >
              <div class="crm-ng-select">
                <ng-select
                  [items]="ejecutivos"
                  bindLabel="nombre"
                  bindValue="valor"
                  placeholder="Buscar usuario..."
                  [(ngModel)]="eventData.assignedTo"
                  appendTo="body"
                  [disabled]="disableAssignSelect"
                >
                  <ng-template ng-label-tmp let-item="item">
                    <div class="selected-option">
                      <img
                        src="assets/svg/user-icon.svg"
                        alt="icono"
                        class="dropdown-icon"
                      />
                      <span>{{ item.nombre }}</span>
                    </div>
                  </ng-template>

                  <ng-template ng-option-tmp let-item="item" let-index="index">
                    <div class="dropdown-option">
                      <img
                        src="assets/svg/user-icon.svg"
                        alt="icono"
                        class="dropdown-icon"
                      />
                      <span>{{ item.nombre }}</span>
                    </div>
                  </ng-template>
                </ng-select>
              </div>
            </div>
          </div>

          <div class="right-column">
            <div class="mt-3">
              <label class="login-label"
                ><p class="color-org d-inline">*</p>
                Prioridad:</label
              >
              <select class="crm-input" [(ngModel)]="eventData.priority">
                <option value="">Selecciona la prioridad del evento</option>
                <option value="Baja">Baja</option>
                <option value="Media">Media</option>
                <option value="Alta">Alta</option>
              </select>
            </div>

            <div class="mt-3">
              <label class="login-label">
                <p class="color-org d-inline">*</p>
                Relacionado con:
              </label>

              <div class="relacionado-container">
                <div class="tipo-selector">
                  <select
                    class="crm-input"
                    [(ngModel)]="tipoRelacionado"
                    (change)="onTipoRelacionadoChange()"
                  >
                    <option value="">Selecciona tipo</option>
                    <option value="CNT">Contacto</option>
                    <option value="ACC">Cuenta</option>
                    <option value="OPP">Oportunidad</option>
                  </select>
                </div>

                <div
                  class="elemento-selector"
                  *ngIf="tipoRelacionado && tipoRelacionado !== 'OTRO'"
                >
                  <div class="crm-ng-select">
                    <ng-select
                      [items]="elementosFiltrados"
                      bindLabel="nombre"
                      bindValue="valor"
                      [placeholder]="getPlaceholderPorTipo()"
                      [(ngModel)]="eventData.relatedTo"
                      [clearable]="true"
                      appendTo="body"
                      (clear)="limpiarSeleccionRelacionado()"
                    >
                      <ng-template ng-label-tmp let-item="item">
                        <div class="selected-option">
                          <img
                            [src]="getIconForTipoRelacionado(tipoRelacionado)"
                            alt="icono"
                            class="dropdown-icon"
                          />
                          <span class="option-text"
                            >{{ item ? item.nombre : getPlaceholderPorTipo()
                            }}</span
                          >
                        </div>
                      </ng-template>

                      <ng-template
                        ng-option-tmp
                        let-item="item"
                        let-index="index"
                      >
                        <div class="dropdown-option">
                          <img
                            [src]="getIconForTipoRelacionado(tipoRelacionado)"
                            alt="icono"
                            class="dropdown-icon"
                          />
                          <span class="option-text">{{ item.nombre }}</span>
                        </div>
                      </ng-template>

                      <ng-template ng-notfound-tmp>
                        <div class="ng-option disabled">
                          No se encontraron {{ getTipoDisplay() }}
                        </div>
                      </ng-template>
                    </ng-select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="mt-4">
          <h5 class="text-semibold">Configuraciones adicionales</h5>
          <div
            class="d-grid prospect-form"
            style="
              grid-template-columns: 1fr 1fr;
              column-gap: 32px;
              align-items: start;
            "
          >
            <div>
              <div class="mt-3 d-flex align-items-center gap-5">
                <label class="login-label"
                  ><p class="color-org d-inline">*</p>
                  Repetir este evento:</label
                >
                <input
                  type="checkbox"
                  id="repeatTask"
                  [(ngModel)]="eventData.repeatTask"
                  (change)="onRepeatTaskChange()"
                  style="
                    margin-left: 15px;
                    transform: translateY(-2px);
                    color: #ea5a10;
                  "
                />
              </div>

              <div *ngIf="showRepeatOptions" class="mt-3">
                <div class="mt-3">
                  <label class="login-label"
                    ><p class="color-org d-inline">*</p>
                    Frecuencia:</label
                  >
                  <select class="crm-input" [(ngModel)]="eventData.frecuencia">
                    <option value="">Selecciona la frecuencia</option>
                    <option value="diaria">Diaria</option>
                    <option value="semanal">Semanal</option>
                    <option value="mensual">Mensual</option>
                    <option value="anual">Anual</option>
                    <option value="personalizadoTR">
                      Personaliza fecha y hora
                    </option>
                  </select>
                </div>

                <div class="d-flex gap-3 mt-3">
                  <div style="flex: 1; margin-right: 12px">
                    <label class="login-label"
                      ><p class="color-org d-inline">*</p>
                      Fecha inicio:</label
                    >
                    <input
                      class="crm-input"
                      type="date"
                      [(ngModel)]="eventData.fechaInicioRep"
                      [value]="getTodayDate()"
                    />
                  </div>
                  <div style="flex: 1">
                    <label class="login-label"
                      ><p class="color-org d-inline">*</p>
                      Fecha fin:</label
                    >
                    <input
                      class="crm-input"
                      type="date"
                      [(ngModel)]="eventData.fechaFinRep"
                      [value]="getTodayDate()"
                    />
                  </div>
                </div>

                <div class="d-flex gap-3 mt-3">
                  <div style="flex: 1; margin-right: 12px">
                    <label class="login-label"
                      ><p class="color-org d-inline">*</p>
                      Hora inicio:</label
                    >
                    <input
                      class="crm-input"
                      type="time"
                      [(ngModel)]="eventData.horaInicioRep"
                      value="10:00"
                    />
                  </div>
                  <div style="flex: 1">
                    <label class="login-label"
                      ><p class="color-org d-inline">*</p>
                      Hora fin:</label
                    >
                    <input
                      class="crm-input"
                      type="time"
                      [(ngModel)]="eventData.horaFinRep"
                      value="10:00"
                    />
                  </div>
                </div>
              </div>
            </div>

            <div>
              <div class="mt-3 d-flex align-items-center gap-5">
                <label class="login-label"
                  ><p class="color-org d-inline">*</p>
                  Recordatorio establecido:</label
                >
                <input
                  type="checkbox"
                  id="reminderCheckbox"
                  [(ngModel)]="eventData.reminderEnabled"
                  (change)="onReminderEnabledChange()"
                  style="margin-left: 15px; transform: translateY(-2px)"
                />
              </div>

              <div *ngIf="showReminderOptions" class="mt-3">
                <div class="mt-3">
                  <label class="login-label"
                    ><p class="color-org d-inline">*</p>
                    Tiempo del recordatorio:</label
                  >
                  <select
                    class="crm-input"
                    [(ngModel)]="eventData.tiempoRecordatorio"
                  >
                    <option value="">
                      Selecciona el tiempo del recordatorio
                    </option>
                    <option value="5min">5 minutos antes</option>
                    <option value="15min">15 minutos antes</option>
                    <option value="30min">30 minutos antes</option>
                    <option value="1h">1 hora antes</option>
                    <option value="1d">1 día antes</option>
                    <option value="2d">2 día antes</option>
                    <option value="personalizadoFR">
                      Personalizar fecha y hora
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>

        <hr class="mt-5 mb-5" />

        <div class="d-flex flex-row justify-center gap-20 mt-2">
          <button class="btn btn-primary-outline" (click)="closeMdl()">
            Cancelar
          </button>

          <button
            class="btn btn-primary"
            (click)="crearEvento()"
            [disabled]="!eventData.title || !eventData.status || !eventData.assignedTo || !eventData.priority"
          >
            Crear Evento
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
